export const getInitialState = (): any => ({
  deleteData: {},
  deleteStatus: 0
});
